import Vue from 'vue'
import App from './App.vue'
import router from './router'
Vue.config.productionTip = false
import Vant from 'vant';
import 'vant/lib/index.css';
import '@vant/touch-emulator';
import './assets/styles/reset.min.css' // global css
import './assets/styles/base.css' // global css
import './assets/font/inter.css' // font
import { store } from './store'
import showTip from './utils/customMessage';
import Loading from '@/components/loading.vue';
Vue.component('Loading', Loading);

Vue.use(Vant);
Vue.prototype.$msg = showTip;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
